import CircleInfoIcon from "assets/icons/CircleInfoIcon";
import {ReactNode} from "react";

export default function InfoBox({children, heading}: { children?: ReactNode; heading?: string }) {
    return (
        <div style={{padding: 12, border: "1px solid #E9EEF5", borderRadius: 6}}>
            <div
                style={{
                    backgroundColor: "#F5F7FA",
                    borderRadius: 4,
                    padding: "12px 16px",
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                }}
            >
                <span style={{fontWeight: 500, color: "#1A1919"}}>{heading}</span>
                <CircleInfoIcon/>
            </div>
            <div>{children}</div>
        </div>
    );
}
